<template>
  <div class="container-custom" :style="styleObject">
    <div class="content-custom" v-on:scroll.passive="handleScroll($event)">
      <!-- M1045: slim bar that takes over search / language once the banner
           (which carries them at the top) has scrolled away. -->
      <div class="moo-compact-anchor">
        <div class="moo-compact" :class="{ 'is-shown': isHeaderCompact || isCompactSearchFocus }">
          <div class="moo-search">
            <i class="material-icons-round moo-search__icon" aria-hidden="true">search</i>
            <input
              class="moo-search__input"
              type="text"
              inputmode="search"
              v-model="searchKeyword"
              :placeholder="$t('order.searchCategoryPlaceholder')"
              aria-label="Search categories"
              @input="getListCategory"
              @focus="isCompactSearchFocus = true"
              @blur="isCompactSearchFocus = false"
            />
          </div>
          <OrderTopBar variant="compact" @lang="syncMenuNames" />
        </div>
      </div>
      <div style="height: 100%">
        <div class="content" style="padding-bottom: 30px">
          <div>
            <!-- M1045: logo, language and search sit on the banner. -->
            <div class="moo-hero" ref="hero">
            <div class="banner" v-if="slidesHomePage && slidesHomePage.length > 1">
              <swiper
                :slides-per-view="1"
                :space-between="0"
                :loop="true"
                :autoplay="{
                  delay: 3000,
                  disableOnInteraction: false,
                }"
                :initialSlide="0"
              >
                <swiper-slide
                  v-for="(value, index) in slidesHomePage"
                  :key="index"
                >
                  <div
                    class="slider"
                    @click="clickLink(value.destination_link)"
                  >
                    <img :src="value.file_url" alt="error" />
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="banner" v-else-if="slidesHomePage && slidesHomePage.length">
              <swiper
                :slides-per-view="1"
                :space-between="0"
                :autoplay="{
                  delay: 3000,
                  disableOnInteraction: false,
                }"
              >
                <swiper-slide
                  v-for="(value, index) in slidesHomePage"
                  :key="index"
                >
                  <div
                    class="slider"
                    @click="clickLink(value.destination_link)"
                  >
                    <img :src="value.file_url" alt="error" />
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <!-- No banner uploaded: a theme-colour band carries the header. -->
            <div v-else class="moo-hero__band"></div>
            <div class="moo-hero__overlay">
              <OrderTopBar variant="overlay" @lang="syncMenuNames" />
              <section class="moo-search-row">
                <div class="moo-search">
                  <i class="material-icons-round moo-search__icon" aria-hidden="true">search</i>
                  <input
                    class="moo-search__input"
                    type="text"
                    inputmode="search"
                    v-model="searchKeyword"
                    :placeholder="$t('order.searchCategoryPlaceholder')"
                    aria-label="Search categories"
                    @input="getListCategory"
                  />
                </div>
              </section>
            </div>
            </div>
            <div>
              <div class="grid">
                <div
                  class="row ms-0"
                  style="
                    padding: 0 20px;
                    margin-right: 0px !important;
                  "
                >
                  <div
                    class="col-6 mt-3 p-0"
                    :class="[index % 2 ? 'ps-2' : 'pe-2']"
                    v-for="(item, index) in categories"
                    :key="index"
                    @click="gotoOrder(item.id)"
                  >
                    <div class="box-category">
                      <div class="c-img">
                        <img
                          :src="item.img_version"
                          alt="error"
                        />
                      </div>
                      <div class="c-name mt-2">
                        <span style="font-weight: bold">{{
                          tName(item.second_name)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      v-if="
        isLogined && checkHideCollectVoucherBox == 0 && showCollectNewVoucher
      "
      style="
        width: 100%;
        height: auto;
        padding: 5px;
        align-items: center;
        display: grid;
        justify-content: center;
        background-color: white;
      "
    >
      <div style="font-weight: 800">Collect new voucher!</div>
      <div
        style="
          align-items: center;
          display: flex;
          width: 100%;
          height: auto;
          justify-content: center;
        "
      >
        <img
          @click="openPopupReward"
          src="../assets/img/collect-reward.png"
          style="width: 48px; margin-right: 5px"
          alt="user1"
        />
        <i
          @click="hideCollectVoucherBox"
          class="material-icons-round opacity-10"
          >close</i
        >
      </div>
    </div> -->
    <footer>
      <Footer></Footer>
      <!-- <VoucherAvailable :isLoadFromCategoryPage="1"></VoucherAvailable> -->
    </footer>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import OrderTopBar from "@/components/OrderTopBar.vue";
import OrderService from "../services/order.service";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle";
import Footer from "@/common/Footer/OrderFooter";
// import VoucherAvailable from "@/common/VoucherAvailable/VoucherAvailable";
import EventBus from "vue3-eventbus";
import { localStorageName, ensureMerchantId } from '@/config/utils';
import {
  collectItemNames,
  loadMenuTranslations,
  prefetchMenuTranslations,
  translatedName,
} from '@/i18n/menuTranslate';

SwiperCore.use([Pagination, Autoplay]);

export default {
  name: "Order",
  components: {
    Swiper,
    SwiperSlide,
    OrderTopBar,
    Footer,
    // VoucherAvailable,
  },
  data() {
    return {
      merchantCode: "",
      branchCode: "",
      pathType: "",
      tableCode: "",
      branch: JSON.parse(localStorage.getItem(localStorageName('BRANCH_INFO'), '')),
      categories: [],
      categorySelect: {},
      groups: [],
      groupSelect: {},
      tagName: "",
      itemGroup: [],
      searchKeyword: "",
      searchTimerId: null,
      itemSearch: [],
      checkHideCollectVoucherBox: localStorage.getItem(
        localStorageName('HIDE-COLLECT-VOUCHER-BOX')
      )
        ? localStorage.getItem(localStorageName('HIDE-COLLECT-VOUCHER-BOX'))
        : 0,
      slidesHomePage: [],
      showCollectNewVoucher: false,
      memberInfo: JSON.parse(localStorage.getItem(localStorageName('memberInfo'), '')),
      isLogined: false,
      tableInfo: {},
      // M1045: banner has scrolled past -> show the slim sticky bar.
      isHeaderCompact: false,
      isCompactSearchFocus: false,
    };
  },
  created() {
    if (this.memberInfo) {
      this.isLogined = true;
    }
  },
  async mounted() {
    $(".modal-backdrop.fade.show").remove();

    const memorize = this.$route.query.memorize ?? null;
    if (memorize) {
      $(".bottom_modal_memorize").click();
    }

    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    this.pathType = this.$route.params.type;
    this.tableCode = this.$route.params.table_code;

    this.tableInfo = JSON.parse(localStorage.getItem('table_' + this.merchantCode.toLowerCase() + '_' + this.branchCode.toLowerCase() + '_' + this.tableCode.toLowerCase(), {}));

    if (this.merchantCode && this.branchCode) {
      await ensureMerchantId(this.branchCode);
      this.getListCategory();
      this.getSlidesHomePage();
    }
    EventBus.on("showCollectNewVoucher", () => {
      setTimeout(() => {
        this.showCollectNewVoucher = true;
      }, 300);
    });
  },
  computed: {
    styleObject() {
      const base =
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color ||
        "#201a1a";
      return {
        "--color": base,
        "--theme-20": this.blendWhite(base, 0.04),
        "--theme-30": this.blendWhite(base, 0.0675),
        "--theme-40": this.blendWhite(base, 0.16),
      };
    },
  },
  methods: {
    // M1045: once the banner's search row is out of view, the slim bar takes over.
    handleScroll(event) {
      if (this.$refs.hero) {
        this.isHeaderCompact = event.target.scrollTop > this.$refs.hero.offsetHeight - 50;
      }
    },
    blendWhite(color, ratio) {
      // Accept #rrggbb, #rgb, or rgb()/rgba() — the merchant-admin colour picker
      // may persist any of these. Only bail if we truly can't parse it.
      if (typeof color !== "string") return color;
      const s = color.trim();
      let r, g, b, m;
      if ((m = s.match(/^#([0-9a-fA-F]{6})$/))) {
        r = parseInt(m[1].slice(0, 2), 16);
        g = parseInt(m[1].slice(2, 4), 16);
        b = parseInt(m[1].slice(4, 6), 16);
      } else if ((m = s.match(/^#([0-9a-fA-F]{3})$/))) {
        r = parseInt(m[1][0] + m[1][0], 16);
        g = parseInt(m[1][1] + m[1][1], 16);
        b = parseInt(m[1][2] + m[1][2], 16);
      } else if ((m = s.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i))) {
        r = +m[1];
        g = +m[2];
        b = +m[3];
      } else {
        return color;
      }
      const mix = (c) => Math.round(ratio * c + (1 - ratio) * 255);
      const h = (v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, "0");
      return "#" + h(mix(r)) + h(mix(g)) + h(mix(b));
    },
    // Category names come from the POS in the source language; this returns the
    // translation for the active locale (or the original on English).
    tName(source) {
      return translatedName(source);
    },

    // Fetch translations for the categories currently on screen. Called after
    // the list loads and whenever the top bar switches language.
    syncMenuNames() {
      const names = collectItemNames(this.categories || []);
      loadMenuTranslations(names, this.$i18n.locale);
      // M1044: have every language ready before the customer switches.
      prefetchMenuTranslations(names);
    },

    getListCategory() {
      this.showLoader();
      let dataForm = {
        menuset_id: this.branch.menuset_id ?? 0,
        search_keyword: this.searchKeyword,
        branch_code: this.branch.branch_code ?? '',
        get_all: 0
      };

      OrderService.getListCategory(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.categories = response.data.data.categories;
            this.syncMenuNames();
            if (this.categories.length) {
              this.categorySelect = this.categories[0];
              this.itemGroup.push({
                tag_name: this.categorySelect.second_name,
                items: this.categorySelect.items,
              });
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.searchItem();
      }, 1000);
    },

    searchItem() {
      this.showLoader();
      let dataForm = {
        menuset_id: this.branch.menuset_id ?? 0,
        search_keyword: this.searchKeyword,
      };

      OrderService.searchItem(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.itemSearch = response.data.data;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
    gotoOrder(id = 0) {
      this.$router.push({ name: "Order", params: {
        merchant_code: this.merchantCode,
        type: this.pathType,
        branch_code: this.branchCode,
        table_code: this.tableCode,
        category_id: id 
      } });
    },
    // gotoMyReward() {
    //   this.$router.push({ name: "MyReward", params: {
    //     merchant_code: this.merchantCode,
    //     type: this.pathType,
    //     branch_code: this.branchCode,
    //     table_code: this.tableCode
    //   } });
    // },
    // openPopupReward() {
    //   $(".btn-show-voucher-available-modal").click();
    // },
    hideCollectVoucherBox() {
      localStorage.setItem(localStorageName('HIDE-COLLECT-VOUCHER-BOX'), 1);
      location.reload();
    },
    getSlidesHomePage() {
      this.showLoader();
      var dataForm = {
        isMintyApi: true,
        branch_code: this.branchCode,
        where_showing: 1,
        is_ordering_online: 1,
      };
      OrderService.getSlidesHomePage(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.slidesHomePage = response.data.data;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    clickLink(link) {
      if (link && link != "") {
        window.open(link);
      }
    },
  },
};
</script>

<style scoped>
.page-header {
  position: relative;
  background: #ffffff;
  padding-bottom: 0 !important;
}

.page-header .container {
  padding: 0 !important;
}

.page-header .container .content {
  /* margin-top: 65px; */
  margin-bottom: 25px;
}

/* M1045: banner carries the header — top bar on top, search row at the bottom. */
.moo-hero {
  position: relative;
}

.moo-hero__band {
  height: 120px;
  background: var(--color);
}

.moo-hero__overlay {
  position: absolute;
  inset: 0;
  z-index: 25;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem 1rem 0.75rem;
  /* Let swipes in the middle of the banner reach the swiper. */
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0) 35%,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.35) 100%
  );
}

.moo-hero__overlay > * {
  pointer-events: auto;
}

.moo-search-row {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}

.moo-hero .moo-search__input {
  padding: 0.65rem 1rem 0.65rem 3rem;
  background: rgba(255, 255, 255, 0.92) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

/* M1045: slim sticky bar shown after the banner scrolls away. */
.moo-compact-anchor {
  position: sticky;
  top: 0;
  z-index: 30;
  height: 0;
}

.moo-compact {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: 60px;
  padding: 0 1rem;
  background: var(--theme-30, #ffffff);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  opacity: 0;
  transform: translateY(-100%);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.moo-compact.is-shown {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.moo-compact .moo-search__input {
  padding: 0.6rem 0.75rem 0.6rem 2.75rem;
}

.moo-compact .moo-search__icon {
  left: 0.85rem;
}

.moo-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.moo-search__icon {
  position: absolute;
  left: 1rem;
  font-size: 22px;
  color: rgba(82, 67, 66, 0.6);
  pointer-events: none;
}

.moo-search__input {
  width: 100%;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: var(--theme-40, rgba(236, 224, 222, 0.4)) !important;
  background-image: none !important;
  border-radius: 1.25rem;
  padding: 1rem 1rem 1rem 3rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--moo-on-surface, #201a1a);
  -webkit-appearance: none;
  appearance: none;
}

.moo-search__input::placeholder {
  color: rgba(82, 67, 66, 0.6);
  font-weight: 500;
}

.banner {
  position: relative;
}

.material-icons-round.active {
  color: var(--color);
}

.box-category {
  width: 100%;
  height: 100%;
  padding: 10px 10px 12px;
  border-radius: 1.25rem;
  text-align: center;
  cursor: pointer;
  background: var(--theme-20, #ffffff);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.box-category .c-img {
  display: flex;
  justify-content: center;
}

.box-category .c-img img {
  width: 100%;
  max-width: 175px;
  height: auto;
  max-height: 175px;
  border-radius: 10px;
}

.container-custom {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 480px;
  margin: 0 auto;
}

.content-custom {
  flex: 1;
  background-color: var(--theme-30, white);
  overflow: auto;
  scrollbar-width: none; /* Firefox */
}

.content-custom::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}

footer {
  background-color: var(--theme-30, white);
  padding-top: 10px;
}

/* webkit solution */
::-webkit-input-placeholder {
  text-align:left !important;
}
/* mozilla solution */
input:-moz-placeholder {
  text-align:left !important;
}
</style>
